import { render } from "./Labs.vue?vue&type=template&id=e6cf79be"
import script from "./Labs.vue?vue&type=script&lang=js"
export * from "./Labs.vue?vue&type=script&lang=js"
script.render = render

export default script